import React from 'react';
import SubmitRubriqTestimonialForm from './SubmitRubriqTestimonialForm';
var SubmitRubriqTestimonial = function SubmitRubriqTestimonial(_ref) {
  var persistTestimonial = _ref.persistTestimonial;
  return /*#__PURE__*/React.createElement(SubmitRubriqTestimonialForm, {
    persistTestimonial: persistTestimonial
  });
};
export default SubmitRubriqTestimonial;